import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CounterState {
  clients: any;
  orders: any;
  cartSets: any;
  cartBooks: any;
  PostOrderType: any;
  users: any;
  clientBooks: any;
  products: any;
}

const initialState: CounterState = {
  clients: [],
  orders: [],
  cartSets: [],
  cartBooks: [],
  PostOrderType: [],
  users: [],
  clientBooks: [],
  products: []
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    storeClients: (state, action: PayloadAction<any>) => {
      state.clients = action.payload;
    },
    storeOrders: (state, action: PayloadAction<any>) => {
      state.orders = action.payload;
    },
    storeCartSets: (state, action: PayloadAction<any>) => {
      state.cartSets = action.payload;
    },
    storeCartBooks: (state, action: PayloadAction<any>) => {
      state.cartBooks = action.payload;
    },
    StorePostOrderType: (state, action: PayloadAction<any>) => {
      state.cartBooks = action.payload;
    },
    StoreUsers: (state, action: PayloadAction<any>) => {
      state.users = action.payload;
    },
    StoreClientBooks: (state, action: PayloadAction<any>) => {
      state.clientBooks = action.payload;
    },
    StoreProducts: (state, action: PayloadAction<any>) => {
      state.products = action.payload;
    },
    // New action to add a single user
    addApplicationUser: (state, action: PayloadAction<any>) => {
      state.users.push(action.payload);
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  storeClients,
  storeOrders,
  storeCartSets,
  storeCartBooks,
  StorePostOrderType,
  StoreUsers,
  StoreClientBooks,
  StoreProducts,
  addApplicationUser
} = counterSlice.actions;

export default counterSlice.reducer;
